import { createShadowRoot, html } from "../lib";

const template = document.createElement("template");

const messageContainerId = "message-container";

template.innerHTML = html`
  <style>
    .loader {
      align-items: center;
      background-color: transparent;
      display: flex;
      justify-content: center;
      gap: 5px;
    }

    .load {
      height: 20px;
      animation-name: load;
      animation-duration: 1.5s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
    }
    @keyframes load {
      to {
        transform: rotate(360deg);
      }
    }

    .arc {
      fill: hsl(0 0 55);
    }

    .message {
      color: hsl(0 0 55);
    }
  </style>

  <div class="loader">
    <svg class="load" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <path
        class="arc"
        d="M 0,50
            A 50,50 0,0,1 100,50
            A 5,5 0,0,1 80,50
            A 20,20 0,0,0 20,50
            A 5,5 0,0,1 0,50 z
            "
      />
    </svg>
    <p id="${messageContainerId}" class="message"></p>
  </div>
`;

class El extends HTMLElement {
  #messageContainer;

  constructor() {
    super();

    const { getElementById } = createShadowRoot(this, template);

    this.#messageContainer = getElementById(messageContainerId);
  }

  set message(message) {
    this.#messageContainer.textContent = message;
  }
}

customElements.define("o-loader", El);

export const createLoader = message => {
  const el = new El();

  el.message = message;

  return el;
};
